export default __webpack_public_path__ + "305a6d254fc984950ae860830834b963.png";